<template>
  <div class="header__learning-unit">
    <div class="mb-4 d-flex justify-content-between">
      <div>
        <div class="h5 display-4 mt-1 mb-2 font-weight-bold header__lu-title text__lu-title">
          {{ name }}
        </div>
        <div v-if="learningUnit.level_type" class="text-primary font-weight-bold my-3">
          <span class="mr-1"
            ><img
              :src="
                learningUnit.level_type === 'CAREER_SPECIFIC'
                  ? require('@/assets/learning-unit-types/specific.svg')
                  : require('@/assets/learning-unit-types/academic.svg')
              "
              style="height: 16px"
            />
          </span>
          <span class="text__mc-type">{{
            learningUnit.level_type === 'CAREER_SPECIFIC' ? 'Career Specific' : 'Academic Focused'
          }}</span>
        </div>
        <div v-show="!hideStatus">
          <!-- <b-badge
            pill
            variant="neutral-primary"
            class="text-primary badge__lu-type mr-2"
          >
            {{ type }}
          </b-badge> -->

          <learning-unit-status-badge ref="badge__lu-status" :learning-unit="learningUnit" />
        </div>
      </div>

      <slot />
    </div>

    <b-alert
      v-if="
        showAlertReview &&
        learningUnit.status === $constants.LEARNING_UNIT_STATUS.SUBMITTED_FOR_PUBLICATION
      "
      ref="alert__submit-publication"
      variant="info"
      show
    >
      <font-awesome-icon icon="clock" class="mr-2"></font-awesome-icon>

      <span>{{ alertSubmitPublicationMessage }}</span>
    </b-alert>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
// import LearningUnitType from "@/models/LearningUnitType";
import LearningUnitStatusBadge from '@/components/LearningUnit/LearningUnitStatusBadge.vue';

export default {
  components: {
    LearningUnitStatusBadge
  },
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    showAlertReview: {
      type: Boolean,
      default: true
    },

    hideStatus: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      alertSubmitPublicationMessage:
        'We have received your application and are currently reviewing it. You will receive an email with the status of your application within 5 - 7 business days.'
    };
  },

  computed: {
    name() {
      return this.learningUnit.name || '';
    }

    // type() {
    //   const { learning_unit_type_id = null } = this.learningUnit;

    //   let type = "";

    //   if (learning_unit_type_id) {
    //     const learningUnitType = LearningUnitType.find(learning_unit_type_id);

    //     if (learningUnitType) {
    //       type = learningUnitType.name;
    //     }
    //   }

    //   return type;
    // },
  }
};
</script>
